import { Container, styled } from "@mui/material";
export const ContentContainer = styled(Container)(({ theme }) => ({
    // All sections share one column unless the page renders a sidebar.
    "&.MuiContainer-maxWidthMd:not(:has([data-content-sidebar]))": {
        [theme.breakpoints.up("md")]: {
            maxWidth: theme.breakpoints.values.sm,
        },
    },
}));
//# sourceMappingURL=ContentContainer.js.map